import { render, staticRenderFns } from "./LogoFooter.vue?vue&type=template&id=4e6d88c3&"
import script from "./LogoFooter.vue?vue&type=script&lang=js&"
export * from "./LogoFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports